import {
    getFeature,
    deleteFeature,
    createFeature,
    updateFeature
} from '../../../services/FeatureService';
import {
    CONFIRMED_GET_FEATURES
} from './FeatureTypes';

export function getFeatureAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'FEATURE_LOADING' });
        getFeature(currentPage, pageSize, searchTerm, filterQuery)
            .then((response) => {
                dispatch(confirmedGetFeatureAction(response.data.data));
            })
            .catch(() => {
                dispatch(confirmedGetFeatureAction({ rows: [], count: 0, pages: 1 }));
            });
    };
}

export function confirmedGetFeatureAction(data) {
    return {
        type: CONFIRMED_GET_FEATURES,
        payload: data,
    };
}

export function deleteFeatureAction(id, history) {
    return (dispatch, getState) => {
        return deleteFeature(id).then((response) => {
            return response;
        });
    };
}

export function createFeatureAction(data) {
    return () => {
        return createFeature(data).then((response) => {
            return response;
        });
    };
}

export function updateFeatureAction(id, data) {
    return () => {
        return updateFeature(id, data).then((response) => {
            return response;
        });
    };
}

